import { ErrorCodes, UploadStatus } from "../../util/UIConstants";

export class ServiceDataModel {
  engagementId: string;
  masterData: MasterDataModel;
  fetchedTimeStamp: Date;
  done: boolean;
  response: any;
  referenceData: any;
  apiResponseReturned: any;
  ErrorCode?: ErrorCodes;
  ErrorMessage?: string;
  datacenterversion?: string;
}

export class MasterDataModel {
  yesNoList: YesNoMasterListModel;
}

export class YesNoMasterListModel {
  values: string[][] = [["Yes"], ["No"]];
}

export class ApiModel {
  Method: string;
  url: string;
  payload: any;
  id: any;
  response: any;
}
